import axios from "axios";
import Cookies from "js-cookie";
import { API } from "./api";


export function formatDate(inputDate) {
    var date = new Date(inputDate);
    if (!isNaN(date.getTime())) {
        // Months use 0 index.
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
    }
  }

  export function separateArray(array) {
    const length = array.length;
    const chunkSize = 4; // Number of items per chunk
  
    const numChunks = Math.ceil(length / chunkSize); // Calculate the number of chunks
  
    const chunks = [];
    for (let i = 0; i < numChunks; i++) {
      const start = i * chunkSize;
      const end = start + chunkSize;
      const chunk = array.slice(start, end);
      chunks.push(chunk);
    }
  
    return chunks;
  }


  export const SaveQuestionnaire = (object)=>{
    console.log(object)
    if(Cookies.get('user')){

    
const email = Cookies.get('user')
   let  resp = axios.post(API+'interview-question-writer/save-interview-questions', {email:email, object});

if(resp === "error"){
    window.alert('Something went wrong. Please try again.')
} else {
    window.alert('Saved!')
}
    } else {
        window.alert('Please Login.')
    }

}


export const UpdateQuestionnaire = (object)=>{
    console.log(object)
    if(Cookies.get('user')){

    
const email = Cookies.get('user')
   let  resp = axios.post(API+'interview-question-writer/update-iq', {email:email, object});

if(resp === "error"){
    window.alert('Something went wrong. Please try again.')
} else {
    window.alert('Saved Changes!')
}
    } else {
        window.alert('Please Login.')
    }

}